import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

interface DisplayedExpertsState {
  expertIds: number[];
}

const initialState: DisplayedExpertsState = {
  expertIds: [],
};

const displayedExpertsSlice = createSlice({
  name: 'displayedExperts',
  initialState,
  reducers: {
    addDisplayedExpert: (state, action: PayloadAction<number>) => {
      if (!state.expertIds.includes(action.payload)) {
        state.expertIds.push(action.payload);
      }
    },
    resetDisplayedExperts: (state) => {
      state.expertIds = [];
    },
  },
});

export const { addDisplayedExpert, resetDisplayedExperts } = displayedExpertsSlice.actions;

export default displayedExpertsSlice.reducer;
